import { createContext } from 'react';

export const AnalyticsModifiersContext = createContext({});

export default AnalyticsModifiersContext;
